import omitProps from '@hocs/omit-props';

/**
 * @deprecated use "useIntl"
 */
export const ejectIntl = omitProps('intl');
